export const PROFILE_NAMESPACE = 'profileModel'
export const PROFILE_FIRSTNAME = 'firstname'
export const PROFILE_EMPLOYER = 'employer'



// WEBPACK FOOTER //
// ./src/models/profile.js